import { Paragraph, SizableText, YStack, shadowStandard } from '@my/ui'
import { SolitoImage } from 'solito/image'
import { ContentCarouselBlock } from './content-carousel.block'

interface ContentCarouselItemProps {
  item: ContentCarouselBlock['items'][0]
  imagePriority?: boolean
}

export const ContentCarouselItem = ({ item, imagePriority }: ContentCarouselItemProps) => {
  return (
    <YStack bg="$white" position="relative" br="$3" flex={1} {...shadowStandard}>
      <YStack borderRadius="$3" bg="$white" width="100%" flex={1}>
        <YStack
          aspectRatio={9 / 5}
          $gtXs={{ aspectRatio: 11 / 7 }}
          width="100%"
          btlr="$3"
          btrr="$3"
          overflow="hidden"
        >
          <SolitoImage
            src={item.image.url}
            alt={item.image.alt || item.title}
            contentFit="cover"
            fill
            sizes="(max-width: 900px) 50vw, 440px"
            priority={imagePriority}
          />
        </YStack>

        <YStack alignItems="center" flex={1} p="$3.5" $gtSm={{ p: '$6' }}>
          <SizableText
            numberOfLines={2}
            textAlign="center"
            size="$6"
            fow="800"
            $gtSm={{ size: '$7', fow: '800' }}
          >
            {item.title}
          </SizableText>
          <Paragraph numberOfLines={2} textAlign="center" size="$4" color="$overlay11" pt="$1.5">
            {item.description}
          </Paragraph>
        </YStack>
      </YStack>
    </YStack>
  )
}
